// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o1Nk","field":"styles_field__329ug","fieldCol":"styles_fieldCol__3hPRx","diffCol":"styles_diffCol__14LCO","diff":"styles_diff__2WTcJ"};